const Spinner = function(dispatcher) {
    this.init = () => {
        dispatcher.on("spinner_show", (data) => {
            let spinner = '<img class="spinner" src="' + commonUrl + '/images/ajax-loader.gif" alt="spinner"/>';
            const bodyText = data.bodyText ? data.bodyText : "Loading";
            data.element.innerHTML = `<span>${bodyText}</span>`+ spinner;
        });
    }
};

export { Spinner }
